export const copyToClipboard = async (text: string, onSuccess?: () => void) => {
  navigator.clipboard
    .writeText(text)
    .then(onSuccess)
    .catch(() => {
      console.error('Failed to copy. Check navigator permits.')
      /* Rejected - text failed to copy to the clipboard */
    })
}
